<template>
  <div class="sui-radio__container" :class="{ 'sui-radio--has_errors': hasErrors }">
    <label class="sui-radio__label">
      <input
        v-model="radio_button_model"
        class="sui-radio__control"
        :value="value"
        :name="name"
        :disabled="disabled"
        type="radio"
      />
      <span class="sui-radio__text">{{ label }}</span>
    </label>
  </div>
</template>

<script setup lang="ts">
  import { toRefs, computed } from 'vue'

  const props = defineProps({
    modelValue: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    name: {
      type: String,
      default: ''
    },
    hasErrors: {
      type: Boolean,
      default: false
    }
  })

  const { disabled, modelValue, label, name, hasErrors } = toRefs(props)

  const emit = defineEmits(['update:modelValue', 'change'])

  const radio_button_model = computed({
    get() {
      return modelValue.value
    },
    set(val: any) {
      emit('update:modelValue', val)
    }
  })
</script>

<style scoped lang="scss">
  .sui-radio {
    &__container {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 8px;
    }

    &__control {
      display: flex;
      justify-content: center;
      align-items: center;
      appearance: none;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      border: 1px var(--stroke-select) solid;
      margin: 0;

      &:checked {
        border: 6px var(--color-button-default) solid;
      }

      &:checked[disabled] {
        border: 6px var(--color-button-disabled) solid;
        background-color: var(--color-icon-secondary);
      }
    }

    &__control[disabled] {
      background-color: var(--color-button-disabled);
    }

    &__label {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      font-size: 16px;
      line-height: 22px;
      font-weight: 400;
      cursor: pointer;
    }

    &--has_errors {
      .sui-radio__control {
        border: 1px var(--color-button-default) solid;

        &:checked {
          border: 6px var(--color-button-default) solid;
        }
      }
    }
  }
</style>
